<script>
export default {
  props: ["clr", "borderClr", "thunderClr"]
};
</script>
<template>
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.1612 18.8136C31.6417 19.2942 31.969 19.9065 32.1015 20.5731C32.2341 21.2396 32.166 21.9306 31.9059 22.5584C31.6458 23.1863 31.2054 23.723 30.6403 24.1005C30.0752 24.4781 29.4108 24.6796 28.7312 24.6796C28.0516 24.6796 27.3873 24.4781 26.8222 24.1005C26.2571 23.723 25.8166 23.1863 25.5565 22.5584C25.2964 21.9306 25.2284 21.2396 25.3609 20.5731C25.4935 19.9065 25.8207 19.2942 26.3012 18.8136C26.6203 18.4945 26.9992 18.2413 27.4161 18.0686C27.8331 17.8959 28.2799 17.807 28.7312 17.807C29.1825 17.807 29.6294 17.8959 30.0463 18.0686C30.4633 18.2413 30.8421 18.4945 31.1612 18.8136"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.324 26.9715H38.6586M18.8047 34.608V14.8165C18.8047 13.9898 19.1331 13.1969 19.7177 12.6123C20.3023 12.0277 21.0952 11.6993 21.9219 11.6993H46.2951C46.6963 11.6992 47.0936 11.7781 47.4643 11.9316C47.8349 12.0851 48.1717 12.3101 48.4554 12.5938C48.7391 12.8774 48.9641 13.2142 49.1176 13.5849C49.2711 13.9556 49.35 14.3529 49.3499 14.7541V34.608C49.35 35.0092 49.2711 35.4064 49.1176 35.7771C48.9641 36.1478 48.7391 36.4846 48.4554 36.7683C48.1717 37.052 47.8349 37.277 47.4643 37.4304C47.0936 37.5839 46.6963 37.6629 46.2951 37.6627H21.8595C21.4583 37.6629 21.061 37.5839 20.6903 37.4304C20.3196 37.277 19.9828 37.052 19.6992 36.7683C19.4155 36.4846 19.1905 36.1478 19.037 35.7771C18.8835 35.4064 18.8046 35.0092 18.8047 34.608V34.608ZM38.6586 20.8628H44.7673H38.6586Z"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.2236 31.5529C33.9568 30.8826 33.5436 30.2803 33.014 29.7902V29.7902C32.118 28.9595 30.9412 28.498 29.7194 28.4982H27.7467C26.5251 28.4982 25.3487 28.9597 24.4529 29.7902V29.7902C23.9215 30.2798 23.5065 30.8821 23.2383 31.5529"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7648 26.7745V31.9619H24.1932C24.3222 31.9589 24.4495 31.9914 24.5613 32.0559C24.673 32.1203 24.7649 32.2142 24.8269 32.3274C24.8889 32.4405 24.9186 32.5685 24.9127 32.6974C24.9069 32.8263 24.8658 32.9511 24.7938 33.0582L19.1666 41.3053C19.0803 41.432 18.956 41.5281 18.8116 41.5796C18.6672 41.6311 18.5102 41.6355 18.3631 41.592C18.2161 41.5486 18.0867 41.4596 17.9935 41.3378C17.9003 41.2161 17.8482 41.0679 17.8446 40.9146V35.7214H13.4195C13.2905 35.7244 13.1632 35.6919 13.0514 35.6274C12.9397 35.563 12.8478 35.469 12.7858 35.3559C12.7238 35.2428 12.6941 35.1148 12.6999 34.9859C12.7058 34.857 12.7469 34.7322 12.8188 34.6251L18.4452 26.3838C18.5315 26.2571 18.6558 26.1611 18.8002 26.1095C18.9446 26.058 19.1017 26.0536 19.2487 26.0971C19.3957 26.1405 19.5252 26.2296 19.6184 26.3513C19.7116 26.473 19.7637 26.6212 19.7673 26.7745H19.7648Z"
      :stroke="borderClr ? borderClr : 'white'"
      stroke-width="5.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5852 40.5089H5.75391"
      :stroke="borderClr ? borderClr : 'white'"
      stroke-width="5.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.67552 34.3982H3.81055"
      :stroke="borderClr ? borderClr : 'white'"
      stroke-width="5.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5852 28.2889H5.75391"
      :stroke="borderClr ? borderClr : 'white'"
      stroke-width="5.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7648 26.7745V31.9619H24.1932C24.3222 31.9589 24.4495 31.9914 24.5613 32.0559C24.673 32.1203 24.7649 32.2142 24.8269 32.3274C24.8889 32.4405 24.9186 32.5685 24.9127 32.6974C24.9069 32.8263 24.8658 32.9511 24.7938 33.0582L19.1666 41.3053C19.0803 41.432 18.956 41.5281 18.8116 41.5796C18.6672 41.6311 18.5102 41.6355 18.3631 41.592C18.2161 41.5486 18.0867 41.4596 17.9935 41.3378C17.9003 41.2161 17.8482 41.0679 17.8446 40.9146V35.7214H13.4195C13.2905 35.7244 13.1632 35.6919 13.0514 35.6274C12.9397 35.563 12.8478 35.469 12.7858 35.3559C12.7238 35.2428 12.6941 35.1148 12.6999 34.9859C12.7058 34.857 12.7469 34.7322 12.8188 34.6251L18.4452 26.3838C18.5315 26.2571 18.6558 26.1611 18.8002 26.1095C18.9446 26.058 19.1017 26.0536 19.2487 26.0971C19.3957 26.1405 19.5252 26.2296 19.6184 26.3513C19.7116 26.473 19.7637 26.6212 19.7673 26.7745H19.7648Z"
      :stroke="thunderClr ? thunderClr : '#E97C0F'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5852 40.5089H5.75391"
      :stroke="thunderClr ? thunderClr : '#E97C0F'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.67552 34.3982H3.81055"
      :stroke="thunderClr ? thunderClr : '#E97C0F'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5852 28.2889H5.75391"
      :stroke="thunderClr ? thunderClr : '#E97C0F'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
